module.exports = __webpack_public_path__ + "media/musikquiz.a6e81416.mp4";